/**
 * Grid Mode Selector — lets shoppers toggle between 2, 3, or 4 column
 * product grids on collection pages.  Choice persists in localStorage.
 *
 * Usage (Liquid):
 *   <grid-mode-selector
 *     data-grid-id="product-grid"
 *     data-default-columns="{{ section.settings.columns_desktop }}"
 *   >
 *     <button type="button" data-columns="2" aria-label="2 columns">…</button>
 *     <button type="button" data-columns="3" aria-label="3 columns">…</button>
 *     <button type="button" data-columns="4" aria-label="4 columns">…</button>
 *   </grid-mode-selector>
 */

const STORAGE_KEY = 'collection-grid-columns';

class GridModeSelector extends HTMLElement {
  connectedCallback() {
    this.grid = document.getElementById(this.dataset.gridId);
    this.defaultColumns = this.dataset.defaultColumns ?? '4';

    if (!this.grid) return;

    const saved = localStorage.getItem(STORAGE_KEY);
    const initial = saved ?? this.defaultColumns;

    this.applyColumns(initial);
    this.setActiveButton(initial);

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const button = event.target.closest('[data-columns]');
    if (!button || button.getAttribute('aria-pressed') === 'true') return;

    const columns = button.dataset.columns;
    this.applyColumns(columns);
    this.setActiveButton(columns);
    localStorage.setItem(STORAGE_KEY, columns);
  }

  applyColumns(columns) {
    const classes = this.grid.classList;

    for (const cls of [...classes]) {
      if (/^grid--\d-col-desktop$/.test(cls)) {
        classes.remove(cls);
      }
    }

    classes.add(`grid--${columns}-col-desktop`);
  }

  setActiveButton(columns) {
    for (const btn of this.querySelectorAll('[data-columns]')) {
      const isActive = btn.dataset.columns === String(columns);
      btn.setAttribute('aria-pressed', String(isActive));
      btn.classList.toggle('is-active', isActive);
    }
  }
}

if (!customElements.get('grid-mode-selector')) {
  customElements.define('grid-mode-selector', GridModeSelector);
}
